// @ts-nocheck
import { configureStore } from '@reduxjs/toolkit';

import reducer from './reducers';

import { getSelectors as ordersSelectors } from './slices/orders';

export const store = configureStore({
    reducer,
});

export default store;

const orders = ordersSelectors((state) => state.accessOrders);
export const selectAccessOrders = (state) => orders.selectAll(state);
